export default __webpack_public_path__ + "static/media/mexicanLogo.8f70ce13.svg";